// src/screens/ParlayScreen.tsx
import { useEffect } from 'react';
import { useParlayStore } from '../stores/parlayStore';
import { ParlayBuilder } from '../components/ParlayBuilder';
import { ParlayCard } from '../components/ParlayCard';
import { ParlayStatus } from '../domain/types';
import { FiClock, FiCheckCircle, FiXCircle, FiX } from 'react-icons/fi';

export function ParlayScreen() {
  const { savedParlays, loadSaved, isLoadingSaved } = useParlayStore();

  useEffect(() => {
    loadSaved();
  }, [loadSaved]);

  const pending = savedParlays.filter(p => p.status === ParlayStatus.PENDING);
  const settled = savedParlays.filter(p => p.status !== ParlayStatus.PENDING);

  const STATUS_ICON: Record<ParlayStatus, React.ReactNode> = {
    [ParlayStatus.PENDING]: <FiClock size={14} />,
    [ParlayStatus.GREEN]: <FiCheckCircle size={14} />,
    [ParlayStatus.RED]: <FiXCircle size={14} />,
    [ParlayStatus.VOID]: <FiX size={14} />,
  };

  const STATUS_COLOR: Record<ParlayStatus, string> = {
    [ParlayStatus.PENDING]: '#19EA4D',
    [ParlayStatus.GREEN]: '#22C55E',
    [ParlayStatus.RED]: '#EF4444',
    [ParlayStatus.VOID]: '#888',
  };

  return (
    <div style={{ padding: '16px', paddingBottom: 100 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>Parlay Builder</h1>
        <span className="parlay-screen-count">{pending.length} PENDENTES</span>
      </div>

      {/* Builder */}
      <ParlayBuilder />

      {/* Salvos */}
      {(savedParlays.length > 0 || isLoadingSaved) && (
        <div style={{ marginTop: 24 }}>
          <h2 style={{ margin: '0 0 16px', fontSize: 18, fontWeight: 700 }}>Parlays Salvos</h2>
          {isLoadingSaved ? (
            <div style={{ textAlign: 'center', color: '#888', padding: 32 }}>Carregando...</div>
          ) : pending.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <h3 style={{ margin: '0 0 8px', fontSize: 13, color: '#888', textTransform: 'uppercase' }}>Pendentes ({pending.length})</h3>
              {pending.map(parlay => (
                <ParlayCard key={parlay.id} parlay={parlay} />
              ))}
            </div>
          ) : null}
          {settled.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <h3 style={{ margin: '0 0 8px', fontSize: 13, color: '#888', textTransform: 'uppercase' }}>Resolvidos ({settled.length})</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {settled.map(parlay => (
                  <ParlayCard key={parlay.id} parlay={parlay} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
